var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPending(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.354,
    height: 31.033,
    viewBox: "0 0 35.354 31.033",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7767",
    "data-name": "Group 7767",
    transform: "translate(0.8 0.8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7764",
    "data-name": "Group 7764",
    transform: "translate(10.762 8.873)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4999",
    "data-name": "Path 4999",
    d: "M14.836,61.195H6.924v1.87a1.142,1.142,0,0,0,.443.906L10.88,66.7l3.513-2.729a1.142,1.142,0,0,0,.443-.906Z",
    transform: "translate(-6.924 -61.195)",
    fill: "none",
    stroke: "#0046a0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5000",
    "data-name": "Path 5000",
    d: "M14.836,69.879H6.924v-1.87a1.142,1.142,0,0,1,.443-.906l3.513-2.729L14.393,67.1a1.142,1.142,0,0,1,.443.906Z",
    transform: "translate(-6.924 -58.869)",
    fill: "none",
    stroke: "#0046a0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7763",
    "data-name": "Group 7763",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4994",
    "data-name": "Path 4994",
    d: "M28.438,77.667a14.722,14.722,0,1,1,1.7-6.88",
    transform: "translate(-0.708 -56.07)",
    fill: "none",
    stroke: "#0046a0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_328",
    "data-name": "Line 328",
    x2: 5.187,
    y2: 3.246,
    transform: "translate(24.709 12.12)",
    fill: "none",
    stroke: "#0046a0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_329",
    "data-name": "Line 329",
    y1: 4.502,
    x2: 3.534,
    transform: "translate(29.898 10.864)",
    fill: "none",
    stroke: "#0046a0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPending);
export default __webpack_public_path__ + "static/media/pending.dd29cce3.svg";
export { ForwardRef as ReactComponent };